import { Image } from '@chakra-ui/react'

import CalSgSvg from '~/assets/img/calsg.svg'

export const Logo = ({ h }: { h?: number | string }) => (
  <Image src={CalSgSvg} h={h ?? 'inherit'} />
)
